import type { StytchB2BClient } from '@stytch/react/b2b';

let registeredClient: StytchB2BClient | null = null;

export function registerStytchClient(client: StytchB2BClient | null): void {
  if (client === null) {
    return; // (app-shell ADR-002)
  }
  registeredClient = client;
}

export function getRegisteredStytchClient(): StytchB2BClient | null {
  return registeredClient;
}
